import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { CustomLink } from '@/components/CustomLink/CustomLink';

export const Row = styled.div`
  display: grid;
  grid-template-columns: 2fr 1.5fr 1fr 1.25fr 1fr 14px;
  gap: 16px;
  align-items: center;
  height: 68px;
  padding: 0 20px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.system.lightBackground};
  }
`;

export const Cell = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.primary.labels};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DateCell = styled(Cell)`
  white-space: normal;
`;

export const ChevronCell = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const Amount = styled(Typography.Body).attrs({ as: 'span' })<{
  $isIncome: boolean;
}>`
  color: ${({ theme, $isIncome }) =>
    $isIncome ? theme.palette.system.green : theme.palette.primary.labels};
  text-align: right;
`;

export const AdLink = styled(CustomLink)`
  color: ${({ theme }) => theme.palette.system.blue};
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;
